/** @format */

import defaultImage from "../../assets/images/default.jpg";
import { baseURL } from "../../util/config";

const formatImageUrl = (imageUrl) => {
	if (!imageUrl) return defaultImage;

	// Normalise backslashes from Windows-style paths
	let formattedUrl = imageUrl.replace(/\\/g, "/");

	// Strip any existing protocol+host so stale/old base URLs (e.g. from
	// previous deployments) don't bypass the current baseURL. This mirrors
	// the mobile app's getImageUrl() helper.
	const withoutHost = formattedUrl.replace(/^https?:\/\/[^/]+\//, "");

	// Prepend the current baseURL
	const base = baseURL.endsWith("/") ? baseURL : `${baseURL}/`;
	return `${base}${withoutHost}`;
};

/**
 * Format a numeric value as a readable amount with thousand separators and decimals.
 * e.g. 1234567.5 → "1,234,567.50"
 * @param {number|string} amount - The value to format
 * @param {number} decimals - Decimal places (default 2)
 * @returns {string} Formatted amount string
 */
export const formatAmount = (amount, decimals = 2) => {
	const num = Number(amount);
	if (isNaN(num)) return "0.00";
	return num.toLocaleString("en", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
};

export default formatImageUrl;
